/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import AppAccountHeaderItemProps from "./AppAccountHeaderItemProps";
import "./AppAccountHeaderItem.scss";

// React-MUI-Menu nutzt das erste Item als Anker für das Popover. Mittels
// forwardRef wird Menu hierzu Zugriff auf das DOM-Element von
// AppAccountHeaderItem gewaehrt.
const AppAccountHeaderItem = React.forwardRef<HTMLLIElement, AppAccountHeaderItemProps>(({ text }, ref) => (
    <MenuItem ref={ref} className="lan-appaccountheaderitem" sx={{ pointerEvents: "none" }}>
        <ListItemText className="lan-appaccountheaderitem__text" primary={text} />
    </MenuItem>
));

export default AppAccountHeaderItem;
